import * as React from "react";
import { getLitbLangFn } from "utils/lang";
import { EmptyPageWrap } from "./styles";
class EmptyPage extends React.Component {
	btnClick = () => {
		location.href = "/";
	};

	render() {
		return (
			<EmptyPageWrap>
				<img className={"img"} src="https://i.ezbuy.sg/FvoovYlN3YZAJP5zH40Y0t0sdf8K" />
				<p className={"text"}>{getLitbLangFn("ErrorMessage")}</p>
				<div className={"btn"} onClick={this.btnClick} style={{}}>
					{getLitbLangFn("GoShopping")}
				</div>
			</EmptyPageWrap>
		);
	}
}

export default EmptyPage;
